import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SOConsolidationEventModel } from "../../../../../../models/aggregates/so-consolidation/index";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
} from "../../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SOConsolidationEventService extends BaseApiTemplateService<SOConsolidationEventModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/event-hdrs/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/event-hdrs/backoffice-ep";
    this.httpClient = http;
  }

  deleteEvent(
    guid: string,
    deleteType: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      console.log(
        "this.endpoint_path && visa.api_domain_url: ",
        visa.api_domain_url + this.endpoint_path
      );
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + "/" + guid + "?delete_type=" + deleteType,
      this.getHttpHeader(visa)
    );
  }
}
